module.exports = __webpack_public_path__ + "media/images/top/feature02-75032ee4e675c87fdf1a1b3a565b650b.jpg";